/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    COMPREHENSIVE_OPTIONAL_FIELDS_FIX
 * Date:         2025-12-29
 * Modified By:  Cursor
 *
 * Description:
 * Added cache-busting to companies search to ensure fresh data.
 *
 * Related Screens / Modules:
 * - client/src/services/companiesService.ts
 */
import axios from "axios";
// ... (rest of imports)
import { apiUrl } from "../config/environment";
import { getAuthHeaders } from "../utils/authUtils";
import { User } from "../interfaces/User";

const api: string = `${apiUrl}/api/users`;

export interface CompanySearchResponse {
  items: User[];
  total: number;
  page: number;
  pages: number;
}

// GET /api/users/search-companies - Search companies that have matching inventory or broadcasts
export async function searchCompanies(params: {
  q?: string;
  page?: number;
  limit?: number;
}): Promise<{ data: CompanySearchResponse }> {
  const searchParams = new URLSearchParams();

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        searchParams.append(key, value.toString());
      }
    });
  }

  const url = searchParams.toString()
    ? `${api}/search-companies?${searchParams.toString()}&_t=${Date.now()}`
    : `${api}/search-companies?_t=${Date.now()}`;

  return axios.get(url, getAuthHeaders()).then((response) => {
    // Map backend response format
    const backendData = response.data.data;
    return {
      ...response,
      data: {
        items: backendData.items,
        total: backendData.pagination.totalItems,
        page: backendData.pagination.page,
        pages: backendData.pagination.totalPages,
      },
    };
  });
}

